import { Grid } from '@mui/material';
import { PAGE } from '../../../constants/page';
import Banner from '../../ui/Banner/Banner';

interface Props {
  children?: React.ReactElement<unknown>;
  isObserver?: boolean
}

const others = [
  {
    title: PAGE.COMPANY.NAME,
    subTitle: PAGE.COMPANY.TEXT,
    url: PAGE.COMPANY.PATH
  },
  {
    title: PAGE.CONTACT.NAME,
    subTitle: PAGE.CONTACT.TEXT,
    url: PAGE.CONTACT.PATH
  }
]

export default function OtherSection(props: Props) {
  return (
    <Grid size={{ sm: 12, lg: 12 }}>
      <Grid container>
        {others.map((o, index) => {
          return (
            <Grid key={index} size={{ md: 6, lg: 6 }} sx={{ width: '100%', padding: '1rem' }}>
              <Banner href={o.url} title={o.title} subTitle={o.subTitle} />
            </Grid>
          )
        })}
      </Grid>
    </Grid>
  )
}